module.exports = __webpack_public_path__ + "static/media/back.cfe1d092.png";